<div class="nav" [class.transparent]="isTransparent">
  <button (click)="router.navigate([''])">
    <img src="assets/Logo.svg" alt="СИЛА ПАМЯТИ" />
  </button>
  <a
    *ngIf="currentUrl === '/'"
    id="main-link"
    (click)="goTo('main')"
    class="my-nav-item d-none d-lg-block active-sec"
    >{{ "main.navbar.main" | translate }}</a
  >
  <a
    *ngIf="currentUrl === '/'"
    id="packages-link"
    (click)="goTo('packages')"
    class="my-nav-item d-none d-lg-block"
    >{{ "main.navbar.packages" | translate }}</a
  >
  <a
    *ngIf="currentUrl === '/'"
    id="terms-link"
    (click)="goTo('terms')"
    class="my-nav-item d-none d-lg-block"
    >Порядок действий</a
  >
  <a
    *ngIf="currentUrl === '/'"
    id="sign-link"
    (click)="goTo('sign')"
    class="my-nav-item d-none d-lg-block"
    >Инструкция</a
  >
  <a
    *ngIf="currentUrl === '/'"
    id="faq-link"
    (click)="goTo('faq')"
    class="my-nav-item d-none d-lg-block"
    >Ответы на вопросы</a
  >
  <!-- <a
    *ngIf="currentUrl === '/'"
    id="mass-media-link"
    (click)="goTo('mass-media')"
    class="my-nav-item d-none d-lg-block"
    >{{ "main.navbar.mass-media" | translate }}</a
  > -->
  <a
    *ngIf="currentUrl === '/'"
    id="contacts-link"
    (click)="goTo('contacts')"
    class="my-nav-item d-none d-lg-block"
    >{{ "main.navbar.contacts" | translate }}</a
  >
  <div class="d-flex align-items-end">
    <div class="d-flex align-items-center">
      <div *ngIf="searchMode">
        <input
          type="text"
          placeholder="{{ 'main.navbar.search' | translate }}"
          [formControl]="searchRequest"
          [matAutocomplete]="auto"
          class="search-input"
          [class.slide-out]="!searchMode"
        />
        <mat-autocomplete #auto="matAutocomplete">
          @for (object of (filteredObjects | async)?.slice(0, 10); track object)
          {
          <mat-option
            (click)="router.navigate(['p', object.uuid])"
            [value]="object.name"
            >{{ object.name }}</mat-option
          >
          }
        </mat-autocomplete>
      </div>
      <button class="d-none d-lg-block" (click)="toggleSearchMode()">
        <img
          class="search-icon me-2"
          [src]="!searchMode ? 'assets/search-icon.svg' : 'assets/close.svg'"
          alt=""
        />
      </button>
    </div>

    <!-- <div class="dropdown my-nav-item me-2">
      <a
        class="dropdown-toggle"
        href="#"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ lang }}
      </a>
      <ul class="dropdown-menu">
        <li>
          <button class="dropdown-item" (click)="setLang('ru')">Ru</button>
        </li>
        <li>
          <button class="dropdown-item" (click)="setLang('by')">By</button>
        </li>
      </ul>
    </div> -->
    <button
      class="main-page-link"
      (click)="router.navigate([''])"
      *ngIf="currentUrl !== '/'"
    >
      <img src="assets/compass.svg" alt="" />
      <span class="d-none d-lg-block">Nekrolog.by</span>
    </button>
    <div *ngIf="currentUrl === '/'" class="hamburger d-lg-none">
      <button (click)="toggleMenu()" mat-icon-button>
        <mat-icon class="hamburger-mobile-menu">menu</mat-icon>
      </button>
    </div>
  </div>
</div>

<!-- мобильное меню -->

<div *ngIf="activeMenu" class="mobile-menu" [class.open]="activeMenu">
  <div class="menu-header">
    <img src="assets/Logo.svg" alt="" />
    <button (click)="toggleMenu()" class="btn">
      <img src="assets/close.svg" alt="" />
    </button>
  </div>
  <div class="row menu-links">
    <a
      id="main-link-mobile"
      (click)="goTo('main'); toggleMenu()"
      class="col-12 menu-link-item active-sec-mobile"
      >Главная</a
    >
    <a
      id="packages-link-mobile"
      (click)="goTo('packages'); toggleMenu()"
      class="col-12 menu-link-item"
      >Услуги</a
    >
    <a
      id="terms-link-mobile"
      (click)="goTo('terms'); toggleMenu()"
      class="col-12 menu-link-item"
      >Порядок действий</a
    >
    <a
      id="sign-link-mobile"
      (click)="goTo('sign'); toggleMenu()"
      class="col-12 menu-link-item"
      >Инструкция</a
    >
    <a
      id="faq-link-mobile"
      (click)="goTo('faq'); toggleMenu()"
      class="col-12 menu-link-item"
      >Ответы на вопросы</a
    >
    <a
      id="contacts-link-mobile"
      (click)="goTo('contacts'); toggleMenu()"
      class="col-12 menu-link-item"
      >{{ "main.navbar.contacts" | translate }}</a
    >
  </div>
  <div class="mobile-search">
    <img src="assets/search-icon.svg" alt="search" />

    <input
      type="text"
      placeholder="{{ 'main.navbar.search' | translate }}"
      [formControl]="searchRequest"
      [matAutocomplete]="auto"
      class="search-input m-0"
    />
  </div>
  <mat-autocomplete #auto="matAutocomplete">
    @for (object of (filteredObjects | async)?.slice(0, 10); track object) {
    <mat-option
      (click)="router.navigate(['p', object.uuid])"
      [value]="object.name"
      >{{ object.name }}</mat-option
    >
    }
  </mat-autocomplete>
  <div class="contact-items-mobile">
    <a class="c-item" href="/">
      <img src="assets/compass.svg" alt="" />
      <div>Nekrolog.by</div>
    </a>
    <a class="c-item" href="https://t.me/" target="_blank">
      <img src="assets/contacts-telegram.svg" alt="" />
      <div>{{ "main.contacts.telegram" | translate }}</div>
    </a>
    <a class="c-item" href="{{'main.contacts.viberAddress' | translate}}" target="_blank">
      <img src="assets/contacts-viber.svg" alt="" />
      <div>{{ "main.contacts.viber" | translate }}</div>
    </a>
    <a class="c-item" href="tel:{{'main.contacts.phone' | translate}}">
      <img src="assets/contacts-phone.svg" alt="" />
      <div>{{ "main.contacts.phone" | translate }}</div>
    </a>
    <a class="c-item">
      <img src="assets/contacts-mail.svg" alt="" />
      <div>{{ "main.contacts.mail" | translate }}</div>
    </a>
  </div>
</div>
